module.exports = __webpack_public_path__ + "static/media/sunil.b11f340c.jpg";